const translationKeys = {
  spendings_overview_title: 'spendings_overview_title',
  spendings_overview_subtitle: 'spendings_overview_subtitle',
  spendings_time_frame_month: 'spendings_time_frame_month',
  spendings_time_frame_year: 'spendings_time_frame_year',
  spendings_filter_accounts_button: 'spendings_filter_accounts_button',
  spendings_time_periods_last_12_months:
    'spendings_time_periods_last_12_months',
  spendings_time_periods_last_30_days: 'spendings_time_periods_last_30_days',
  spendings_time_periods_last_pay_day: 'spendings_time_periods_last_pay_day',
  spendings_legend_fixed_expenses: 'spendings_legend_fixed_expenses',
  spendings_legend_daily_expenses: 'spendings_legend_daily_expenses',
  spendings_legend_savings: 'spendings_legend_savings',
  spendings_overview_spending_history_title:
    'spendings_overview_spending_history_title',
  spendings_meta_category_title_fixed: 'spendings_meta_category_title_fixed',
  spendings_meta_category_title_daily_expenses:
    'spendings_meta_category_title_daily_expenses',
  spendings_meta_category_title_savings:
    'spendings_meta_category_title_savings',
  spendings_header_total_label: 'spendings_header_total_label',
  spendings_category_cell_transactions: 'spendings_category_cell_transactions',
  spendings_main_category_categories_filter:
    'spendings_main_category_categories_filter',
  spendings_main_category_retailers_filter:
    'spendings_main_category_retailers_filter',
  spendings_breadcrumb_home: 'spendings_breadcrumb_home',
  spendings_breadcrumb_overview: 'spendings_breadcrumb_overview',
  spendings_meta_category_subtitle_total_label:
    'spendings_meta_category_subtitle_total_label',
  spendings_transaction_details_payment_date:
    'spendings_transaction_details_payment_date',
  spendings_transaction_details_from: 'spendings_transaction_details_from',
  spendings_transaction_details_receipt:
    'spendings_transaction_details_receipt',
  spendings_transaction_details_receipt_upload:
    'spendings_transaction_details_receipt_upload',
  spendings_transaction_details_change_category:
    'spendings_transaction_details_change_category',
  spendings_transaction_details_hide_in_spending:
    'spendings_transaction_details_hide_in_spending',
  spendings_transaction_details_hide_in_spending_description:
    'spendings_transaction_details_hide_in_spending_description',
  spendings_transaction_details_save: 'spendings_transaction_details_save',
  spendings_transaction_details_error: 'spendings_transaction_details_error',
  spendings_transaction_details_account_error:
    'spendings_transaction_details_account_error',
  spendings_transaction_details_amount: 'spendings_transaction_details_amount',
  spendings_transaction_details_transaction_type:
    'spendings_transaction_details_transaction_type',
  spendings_transaction_details_card: 'spendings_transaction_details_card',
  spendings_transaction_details_booked: 'spendings_transaction_details_booked',
  spendings_transaction_details_detail_section_title:
    'spendings_transaction_details_detail_section_title',
  spendings_transaction_details_heading:
    'spendings_transaction_details_heading',
  spendings_transaction_details_recipient:
    'spendings_transaction_details_recipient',
  spendings_transaction_details_id: 'spendings_transaction_details_id',
  spendings_transaction_details_transaction_type_debit_card:
    'spendings_transaction_details_transaction_type_debit_card',
  spendings_transaction_details_transaction_type_visa_card:
    'spendings_transaction_details_transaction_type_visa_card',
  spendings_transaction_details_transaction_type_credit_card:
    'spendings_transaction_details_transaction_type_credit_card',
  spendings_transaction_details_transaction_type_atm:
    'spendings_transaction_details_transaction_type_atm',
  spendings_transaction_details_transaction_type_loan:
    'spendings_transaction_details_transaction_type_loan',
  spendings_transaction_details_transaction_type_dom_pay:
    'spendings_transaction_details_transaction_type_dom_pay',
  spendings_transaction_details_transaction_type_transfer:
    'spendings_transaction_details_transaction_type_transfer',
  spendings_transaction_details_transaction_type_efaktura:
    'spendings_transaction_details_transaction_type_efaktura',
  spendings_transaction_details_transaction_type_morsom_sparing:
    'spendings_transaction_details_transaction_type_morsom_sparing',
  spendings_transaction_details_transaction_type_int_pay:
    'spendings_transaction_details_transaction_type_int_pay',
  spendings_transaction_details_transaction_type_salary:
    'spendings_transaction_details_transaction_type_salary',
  spendings_transaction_details_transaction_type_pension:
    'spendings_transaction_details_transaction_type_pension',
  spendings_transaction_details_transaction_type_incoming:
    'spendings_transaction_details_transaction_type_incoming',
  spendings_error_title: 'spendings_error_title',
  spendings_error_subtitle: 'spendings_error_subtitle',
  spendings_widget_empty_state_text: 'spendings_widget_empty_state_text',
  spendings_transactions_empty_state_text:
    'spendings_transactions_empty_state_text',
  spendings_uncategorised_widget_title: 'spendings_uncategorised_widget_title',
  spendings_uncategorised_widget_text: 'spendings_uncategorised_widget_text',
  spendings_uncategorised_widget_button:
    'spendings_uncategorised_widget_button',
  spendings_uncategorised_transactions_title:
    'spendings_uncategorised_transactions_title',
  spendings_uncategorised_transactions_subtitle:
    'spendings_uncategorised_transactions_subtitle',
  spendings_uncategorised_transactions_breadcrumb_title:
    'spendings_uncategorised_transactions_breadcrumb_title',
  spendings_transaction_details_spendings_heading:
    'spendings_transaction_details_spendings_heading',
  spendings_transaction_details_spendings_cell_content:
    'spendings_transaction_details_spendings_cell_content',
  spendings_edit_spendings_category_heading:
    'spendings_edit_spendings_category_heading',
  spendings_edit_spendings_category_breadcrumb:
    'spendings_edit_spendings_category_breadcrumb',
  spendings_accounts_choose_account_heading:
    'spendings_accounts_choose_account_heading',
  spendings_accounts_choose_account_subheading:
    'spendings_accounts_choose_account_subheading',
  spendings_accounts_choose_account_list_heading:
    'spendings_accounts_choose_account_list_heading',
  spendings_accounts_choose_account_save:
    'spendings_accounts_choose_account_save',
  spendings_accounts_choose_account_error:
    'spendings_accounts_choose_account_error',
  spendings_edit_spendings_category_title:
    'spendings_edit_spendings_category_title',
  spendings_edit_spendings_category_error_title:
    'spendings_edit_spendings_category_error_title',
  spendings_edit_spendings_category_error_message:
    'spendings_edit_spendings_category_error_message',
  spendings_edit_spendings_category_confirm_button:
    'spendings_edit_spendings_category_confirm_button',
};

Object.freeze(translationKeys);

export default translationKeys;
